import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { useColorMode } from "../../styles/ColorModeProvider";

const ThemeToggle = (props) => {
  const { mode, toggleColorMode } = useColorMode();
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}>
      <IconButton onClick={toggleColorMode} color="inherit" {...props}>
        {isDark ? (
          <LightModeOutlinedIcon />
        ) : (
          <DarkModeOutlinedIcon />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;